export const setViewItemEventOnNewVehiclePageLoad = (
  formWrapperSelector = '.showcase-new-cars__conversion-form',
) => {
  window.addEventListener('load', () => {
    const { toBool } = window.helpers;

    const formWrapper = document.querySelector(formWrapperSelector);

    if (!formWrapper) return;

    const data = formWrapper.dataset;
    const isOffer = toBool(data.isOffer);

    if (isOffer) {
      const offerData = JSON.parse(data.offerData);

      window.DDMDataLayerService.addViewItemEvent(offerData);

      return;
    }

    const newVehicleData = JSON.parse(data.newVehicleData);

    const adaptedItem =
      window.DDMDataLayerHelpers.NewVehiclesAdapter.adaptItem(newVehicleData);

    window.DDMDataLayerService.addViewItemEvent(adaptedItem);
  });
};
